/**
 * The prototype's dense-form field (TMMAPP-0103, visual contract §14; P:2297-2452): the label is 11px
 * in `textLabel` with a gap of 5, and the input's padding is 9 11. Pass the result as the `sx` of a
 * `TextField` or `FormControl` (a `Select` sits inside a `FormControl`); the field keeps the theme's
 * border, radius and focus ring. The editor dialogs and the item dialog are dense; everything else
 * keeps the standard field.
 */
import type { SystemStyleObject } from '@mui/system';
import type { Theme } from '@mui/material';
import type { AppTokens } from '@/theme/tokens';

export function denseFieldSx(tokens: AppTokens): SystemStyleObject<Theme> {
  return {
    '& .MuiInputLabel-root, & .MuiFormLabel-root': {
      fontSize: 11,
      lineHeight: '16px',
      marginBottom: '5px',
      color: tokens.textLabel('surfaceRaised'),
    },
    '& .MuiOutlinedInput-input': { padding: '9px 11px' },
    '& .MuiOutlinedInput-root.MuiInputBase-multiline': { padding: '9px 11px' },
  };
}
